// ----------------------------------------------------------------------

/** 블로그 목록 머리 */
export const BLOG_HEAD = {
  eyebrow: 'BLOG',
  title: '뷰티 마케팅 인사이트',
  lead: '뷰티 소셜 데이터로 읽은 트렌드와 소재 인사이트를 전해 드립니다.',
} as const;

/** 맨 아래 띠 — 단추 셋의 글과 가는 곳 */
export const BLOG_CTA = {
  title: '지금 바로 시작하고 경쟁사보다 앞서가세요',
  lead: '흩어진 소셜 데이터는 캐치모먼츠가 한 곳에 모아 드릴게요.',
  trial: '무료로 시작하기',
  consult: '실시간 상담하기',
  consultUrl: 'https://catchmoments.channel.io',
  demo: '데모 세션 요청하기',
  demoUrl: 'https://calendar.app.google/ESzTx9Qhh2XbhdMaA',
} as const;

/** 글 상세 */
export const BLOG_DETAILS = {
  backToList: '블로그 목록',
  recentTitle: '최근 글',
  notFoundTitle: '글을 찾을 수 없어요',
  notFoundAction: '블로그 목록으로',
} as const;
